module.exports = __webpack_public_path__ + "a869f452b43a4c5304d2263886812a76.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/sehnsuchtslieder.jpg
// module id = 780
// module chunks = 0